import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { PatientCareCenterNoteNavAnchor, PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import { AlEval, AlMod, AlOther, AlTherAct, AlTherEx, AlSelfCare, AlNeuro, AlGait, AlManual, AlAqua, AlSpeechTest, AlPhysPerfTest, AlTemplate } from 'PatientCareCenter/Note/AL';

class PatientCareCenterNoteAL extends React.Component {


    handleClear() {
        this.props.clearAl(this.props.noteId);
    }

    render() {
        return (
            <PatientCareCenterNoteSection id='al' name='Activity Log' showClear={false} onClear={() => this.handleClear()} refProp={this.props.refProp}>
                <AlTemplate />
                <PatientCareCenterNoteNavAnchor id='al_evals'>
                    <AlEval />
                </PatientCareCenterNoteNavAnchor>
                <PatientCareCenterNoteNavAnchor id='al_theract'>
                    <AlTherAct />
                </PatientCareCenterNoteNavAnchor>
                <PatientCareCenterNoteNavAnchor id='al_selfcare'>
                    <AlSelfCare />
                </PatientCareCenterNoteNavAnchor>
                <PatientCareCenterNoteNavAnchor id='al_neuro'>
                    <AlNeuro />
                </PatientCareCenterNoteNavAnchor>
                <PatientCareCenterNoteNavAnchor id='al_therex'>
                    <AlTherEx />
                </PatientCareCenterNoteNavAnchor>
                <PatientCareCenterNoteNavAnchor id='al_manual'>
                    <AlManual />
                </PatientCareCenterNoteNavAnchor>
                <PatientCareCenterNoteNavAnchor id='al_gait'>
                    <AlGait />
                </PatientCareCenterNoteNavAnchor>
                <PatientCareCenterNoteNavAnchor id='al_aqua'>
                    <AlAqua />
                </PatientCareCenterNoteNavAnchor>
                {this.props.isSpeech && <PatientCareCenterNoteNavAnchor id='al_speech'>
                    <AlSpeechTest />
                </PatientCareCenterNoteNavAnchor>}
                <PatientCareCenterNoteNavAnchor id='al_mod'>
                    <AlMod />
                </PatientCareCenterNoteNavAnchor>
                <PatientCareCenterNoteNavAnchor id='al_other'>
                    <AlOther />
                </PatientCareCenterNoteNavAnchor>
                <PatientCareCenterNoteNavAnchor id='al_ppt'>
                    <AlPhysPerfTest />
                </PatientCareCenterNoteNavAnchor>
            </PatientCareCenterNoteSection>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        clearAl: bindActionCreators(noteActions.clearAl, dispatch)
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let isSpeechEnabled = state.entities.masterData.PROPS ? state.entities.masterData.PROPS['PTERO_SPEECH_ENABLED'].PRVALUE === 'true' : false;
    let isSpeech = state.entities.admissions[epno].discipline === "ST" && isSpeechEnabled;

    return {
        noteId: noteId,
        isSpeech
    };
}

const connectedPatientCareCenterNoteAL = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteAL);
export { connectedPatientCareCenterNoteAL as PatientCareCenterNoteAL };

